// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"04142ac1","453":"825386d9","516":"95aeb0d3","794":"42c9764c","983":"a46c0937"}[chunkId] + ".chunk.js";
};